import { Link } from "react-router-dom";
import {
  Airplane,
  Buildings,
  ForkKnife,
  Sparkle,
  ChatCircleDots,
  MapPinLine,
} from "@phosphor-icons/react";

const features = [
  {
    icon: Airplane,
    title: "Budget Flights",
    desc: "Compare across Google Flights, Skyscanner & MakeMyTrip with AI hacks for the cheapest fares from Indian metros.",
    to: "/explore",
    testid: "feat-flights",
    color: "#2A7FB8",
    bg: "rgba(42,127,184,0.10)",
  },
  {
    icon: Buildings,
    title: "Smart Stays",
    desc: "Side-by-side rates from Booking, Agoda, Airbnb & MakeMyTrip filtered for vibe, location and budget.",
    to: "/explore",
    testid: "feat-stays",
    color: "#5FB3E3",
    bg: "rgba(95,179,227,0.14)",
  },
  {
    icon: ForkKnife,
    title: "Food & Activities",
    desc: "Curated must-do experiences and food spots — with veg/Indian-friendly tags baked in.",
    to: "/explore",
    testid: "feat-food",
    color: "#FF7E4D",
    bg: "rgba(255,126,77,0.12)",
  },
  {
    icon: ChatCircleDots,
    title: "AI Country Experts",
    desc: "Twelve dedicated experts. Ask anything — visa step-by-step, eSIMs, transport, monsoon timing.",
    to: "/experts",
    testid: "feat-experts",
    color: "#2D9D78",
    bg: "rgba(45,157,120,0.12)",
  },
  {
    icon: MapPinLine,
    title: "AI Trip-Board",
    desc: "Pick your cities, get a beautiful day-wise itinerary. Edit, then download a designer PDF.",
    to: "/itinerary",
    testid: "feat-itinerary",
    color: "#F4B942",
    bg: "rgba(244,185,66,0.16)",
  },
  {
    icon: Sparkle,
    title: "Made for India",
    desc: "Prices in ₹, direct flights from Delhi/Mumbai/Bengaluru, halal & veg cues, embassy contacts.",
    to: "/",
    testid: "feat-india",
    color: "#2A7FB8",
    bg: "rgba(42,127,184,0.10)",
  },
];

export const FeatureStrip = () => {
  return (
    <section
      data-testid="features-section"
      className="relative max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-28"
    >
      <div className="mb-8 sm:mb-12">
        <span className="kicker">— What you get</span>
        <h2 className="font-serif text-3xl sm:text-5xl mt-3 max-w-3xl text-slate-900">
          Everything for the trip,{" "}
          <span className="italic" style={{ color: "#2A7FB8" }}>
            none of the tabs.
          </span>
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {features.map((f) => (
          <Link
            to={f.to}
            key={f.title}
            data-testid={f.testid}
            className="card-surface rounded-2xl p-6 flex flex-col gap-4"
          >
            <span
              className="w-12 h-12 rounded-xl grid place-items-center"
              style={{ background: f.bg }}
            >
              <f.icon size={22} weight="duotone" color={f.color} />
            </span>
            <h3 className="font-serif text-2xl leading-tight text-slate-900">
              {f.title}
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">{f.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};
